export function normalizeILPhoneToE164(phoneRaw = "") {
  // Best-effort for Israeli numbers
  // Supports: 05XXXXXXXX, +9725XXXXXXXX, 9725XXXXXXXX, with spaces/dashes
  const p = String(phoneRaw).replace(/[^\d+]/g, "").trim();

  if (!p) return "";

  if (p.startsWith("+")) return p.replace("+", ""); // wa.me expects no "+"
  if (p.startsWith("972")) return p;
  if (p.startsWith("0")) return `972${p.slice(1)}`;

  // fallback: assume already countryless digits; still return as-is
  return p;
}

export function buildOrderSummaryHe(order) {
  const dateStr = order?.date ? new Date(order.date).toLocaleDateString("he-IL") : "";
  const tagsStr = (order?.tags || []).map((t) => t?.name).filter(Boolean).join(", ");

  const lines = [
    `שלום ${order?.name || ""},`,
    `רציתי לעדכן לגבי ההזמנה שלך:`,
    "",
    `• מוצר: ${order?.product || "-"}`,
    `• סטטוס: ${order?.status || "-"}`,
    `• תאריך: ${dateStr || "-"}`,
    order?.comments ? `• הערות: ${order.comments}` : null,
    tagsStr ? `• תגיות: ${tagsStr}` : null,
    "",
    `אם יש שינוי/שאלה—אשמח לעזור.`,
  ].filter(Boolean);

  return lines.join("\n");
}

export function buildWaMeUrl(phoneRaw, message) {
  const phone = normalizeILPhoneToE164(phoneRaw);
  if (!phone) return "";
  const text = encodeURIComponent(message || "");
  return `https://wa.me/${phone}${text ? `?text=${text}` : ""}`;
}
